let result;

export const msntPhotoThumbGallery = () => {
  if (result) return Promise.resolve(result);
  return import(/* webpackPrefetch: true */ './msnt-photo-thumb-gallery').then((module) => {
    result = module;
    return module;
  });
};